import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';

export default () => (
  <SectionContainer id='business-continuity-plan-header'>
    <Row align='center'>
      <Col medium={8}>
        <Typography
          component='h1'
          nextElement='typography'
          align='center'>
          Business Continuity Plan
        </Typography>
        <Typography nextElement='typography'>
          Northwestern Mutual Investment Services, LLC &#40;&#34;NMIS&#34;&#41; has a business continuity plan to provide for an orderly return to normal business operations after a significant disruption. Where necessary, NMIS has integrated its plan with the business continuity plan of its parent, The Northwestern Mutual Life Insurance Company, and plans of key third&#45;party services providers.
        </Typography>
        <Typography nextElement='typography'>
          While a catastrophic event may negatively impact our ability to continue to transact business, we have attempted
          to identify potential disruptions and methods to continue to operate in the event such disruptions occur.
          The strategy of NMIS&#39;s business continuity plan is to take all reasonable and appropriate steps to protect
          our people, our infrastructure, the services provided to our customers, and the services provided to
          our field.
        </Typography>
        <Typography nextElement='typography'>
          NMIS&#39;s business continuity plan addresses: data back up and recovery&#59; mission critical systems&#59; financial
          and operational assessments&#59; alternative communications with customers, employees, and regulators&#59; alternate
          physical location of employees&#59; critical supplier, contractor, bank and counter&#45;party impact&#59; regulatory
          reporting&#59; and assuring our customers prompt access to their funds and securities if we were unable to
          continue our business.
        </Typography>
        <Typography nextElement='typography'>
          The information below is intended as a synopsis of our business continuity plan. Since the timing and extent
          of significant business disruptions are by nature unpredictable, we have reserved flexibility in our
          plan to allow us to respond to tangible events in the manner we deem appropriate as they occur.
        </Typography>
        <Typography
          component='h2'
          nextElement='typography'>
          Contacting Us
        </Typography>
        <Typography nextElement='typography'>
          Your primary contact in the event of a significant business disruption affecting the home office is your
          financial representative. If your financial representative or the network office to which your financial
          representative is associated with experiences a significant business disruption, you can contact the
          home office at&nbsp;
          <Link
            variant='primaryDeemphasize'
            linkUrl='tel:18666647737'>
            1&#45;866&#45;664&#45;7737
          </Link>
          . If a significant business disruption affects your ability
          to contact our home office please go to the media section of our website at&nbsp;
          <Link
            id="business-continuity-plan-nm-contact-link"
            variant='primaryDeemphasize'
            linkUrl="https://www.northwesternmutual.com">
            www.northwesternmutual.com
          </Link>
          &nbsp;for instructions on how to obtain information regarding your accounts.
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          Strategy by <WidowBlock>Disruption Type</WidowBlock>
        </Typography>
        <Typography nextElement='typography'>
          The strategy of NMIS&#39;s business continuity plan is to address three scenarios in which a Northwestern Mutual
          campus is impacted by a local business disruption. The scenarios are &#40;1&#41; part or all of the Milwaukee,
          Wisconsin Campus disabled, &#40;2&#41; part or all of the Franklin, Wisconsin Campus disabled, and &#40;3&#41; significant
          portion of staff unable to work &#40;for example, pandemic&#41;. In all scenarios, NMIS plans to continue business
          and notify our clients through our website or via the home office phone number which are both listed
          in the paragraph above. If the significant business disruption is so severe that it prevents NMIS from
          processing transactions, NMIS will take all necessary steps to assure our clients&#39; prompt access to their
          funds and securities.
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          Milwaukee Campus <WidowBlock>Only Disruption</WidowBlock>
        </Typography>
        <Typography nextElement='typography'>
          If NMIS loses the ability to perform business at part or all of the Milwaukee campus, the staff associated
          with the mission critical functions will be relocated to an established off&#45;site location outside of
          the affected area. The firm expects to recover and resume business as soon as reasonably practical depending
          on the severity of the disruption.
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          Franklin Campus <WidowBlock>Only Disruption</WidowBlock>
        </Typography>
        <Typography nextElement='typography'>
          If NMIS loses the ability to perform business at part or all of the Franklin campus, the staff associated
          with the mission critical functions will be relocated to an established off&#45;site location outside of
          the affected area. The firm expects to recover and resume business as soon as reasonably practical depending
          on the severity of the disruption.
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          Staff Only Disruption
        </Typography>
        <Typography nextElement='typography'>
          If a staff only disruption &#40;for example, pandemic&#41; was to occur at either the Milwaukee or Franklin campus,
          the firm will redirect the available staff, to service the critical and essential processes needed to
          keep the firm running with little impact. If necessary, certain key employees will work from an established
          remote location to assist in the recovery of business operations.
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          Changes and Modifications
        </Typography>
        <Typography disableBottomPadding>
          The firm may, from time to time, alter or revise the plan as necessary to support current business needs.
          Certain aspects of the plan are tested on a regular basis and updated as necessary. For a current copy
          of this notice, go to&nbsp;
          <Link
            id='business-continuity-plan-nm-changes-link'
            variant='primaryDeemphasize'
            linkUrl='https://www.northwesternmutual.com'>
            www.northwesternmutual.com
          </Link>
          &nbsp;and search business continuity or contact your Northwestern Mutual representative. If you have questions about our business continuity plan, please contact us at&nbsp;
          <Link
            variant='primaryDeemphasize'
            linkUrl='tel:18666647737'>
            1&#45;866&#45;664&#45;7737
          </Link>.
        </Typography>
      </Col>
    </Row>
  </SectionContainer>
);
